import { ButtonTheme } from 'common/components/buttons/button-theme';
import BaseModal from 'common/components/modal/base-modal';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeBudgetScenarioSaveModal,
  selectBudgetScenarioSaveModalState
} from './budget-scenario-save-modal.slice';
import { FC, useState } from 'react';
import { changeBudgetScenarioName } from '../edit-budget-scenario.slice';

const BudgetScenarioSaveModal: FC = () => {
  const dispatch = useDispatch();

  const { isOpen, budgetId, budgetScenarioName } = useSelector(
    selectBudgetScenarioSaveModalState
  );

  const [editedBudgetScenarioName, setEditedBudgetScenarioName] =
    useState<string>(budgetScenarioName || '');

  const [errorMessage, setErrorMessage] = useState<string>('');

  return isOpen ? (
    <>
      <BaseModal
        title="Budget Scenario Name Confirmation Required"
        confirmButtonText="Save"
        cancelButtonText="Cancel"
        confirmButtonTheme={ButtonTheme.PRIMARY}
        cancelButtonTheme={ButtonTheme.CANCEL}
        onConfirm={() => {
          if (!editedBudgetScenarioName.trim()) {
            setErrorMessage('Please enter a valid scenario name.');
            return;
          }

          setErrorMessage('');

          dispatch(
            changeBudgetScenarioName({
              budgetId,
              scenarioName: editedBudgetScenarioName
            })
          );
        }}
        onCancel={() => dispatch(closeBudgetScenarioSaveModal())}
      >
        <div className="p-4">
          <p>
            Please confirm or change the name of the budget scenario before
            saving:
          </p>
          {errorMessage && (
            <div className="text-red-500 mt-2">{errorMessage}</div>
          )}
          <input
            type="text"
            className={`mt-2 w-full p-2 border ${
              errorMessage ? 'border-error-300' : 'border-gray-300'
            } rounded`}
            value={editedBudgetScenarioName}
            onChange={(e) => setEditedBudgetScenarioName(e.target.value)}
            placeholder={'Enter scenario name'}
          />
        </div>
      </BaseModal>
    </>
  ) : null;
};

export default BudgetScenarioSaveModal;
